import axios from "axios";
import CommonHelper from "../helper/CommonHelper";

/*
 * Performs the axios call for the sendErrorEmail function
 */
async function sendErrorEmail(location, error) {
  if (error && error.toString() && !error.toString().includes("Request aborted")) {
    let userLabel = "";

    if (CommonHelper.currentUserData.value) {
      userLabel = CommonHelper.currentUserData.value.email ? `${CommonHelper.currentUserData.value.name} (${CommonHelper.currentUserData.value.email})` : CommonHelper.currentUserData.value.name;
      userLabel = encodeURIComponent(userLabel);
    }

    const url = `${process.env.VUE_APP_API_GATEWAY}sendErrorEmail/?location=${location}&error=${encodeURIComponent(error.toString())}&userLabel=${userLabel}&key=${process.env.VUE_APP_API_KEY}`;

    await axios.get(url);
  }
}

export default {
  sendErrorEmail
};